import { Navigate, Outlet, useSearchParams } from "react-router-dom"
import { useAuthContext } from "./AuthProvider"
import { useEffect } from "react"
import { AuthService } from "../services/authService"
import { useNavigate, useLocation } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"
import { StorageKeys } from "@utils/user-config"

export const ProtectedRoute: React.FC = () => {
	const { isAuthenticated, isLoading, refreshSession } = useAuthContext()
	const [searchParams, setSearchParams] = useSearchParams()
	const navigate = useNavigate()
	const location = useLocation()

	useEffect(() => {
		const validateSession = async () => {
			const legacyToken = searchParams.get("z")
			if (legacyToken) {
				searchParams.delete("z")
				const cleanUrl =
					location.pathname +
					(searchParams.toString() ? `?${searchParams.toString()}` : "")

				window.history.replaceState(null, "", cleanUrl)

				if (!isAuthenticated && !isLoading) {
					try {
						const result = await AuthService.validateLegacyToken(legacyToken)
						if (result?.access_token && result?.id_token) {
							await refreshSession(result.access_token, result.id_token)
							secureLocalStorage.setItem(
								StorageKeys.LEGACY_AUTHOMATIC_REDIRECT_ALREADY_DONE,
								"true"
							)
							return
						}
					} catch (error) {
						console.error("Failed to validate legacy token:", error)
						navigate("/login", { replace: true })
					}
				}
			}
		}

		validateSession()
	}, [
		isAuthenticated,
		isLoading,
		refreshSession,
		searchParams,
		setSearchParams,
		navigate,
		location.pathname
	])

	if (isLoading) return null

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />
	}

	return <Outlet />
}

export default ProtectedRoute
